import { object } from "prop-types";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { AccessType, Link, ResponsiveImage } from "@quintype/components";
import useViewPort from "../../../../hook/useViewPort";
import "./hero-1-layout.m.css";
import { useSelector } from "react-redux";
import { userFavouritesApi, validateFavLimit } from "../../../../components/utils/user-favourites-api";
import { currentUser } from "@quintype/bridgekeeper-js";
import SocialShare from "../../../../components/story-templates/social-share";
import { getCollections } from "../../../../../api/utils";

const Hero1Layout = ({ collection, config, initAccessType, getSubscriptionForUser, cancelSubscription, isATGlobal, member }) => {
  const [favSelected, setFevSelected] = useState(false);
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");
  const { currentImageIndex } = useViewPort();
  const defaultImage = get(config, ["publisher-attributes", "defaultImageKey"], "");
  const itemTypesCollections = collection.items?.filter((item) => item.type === "collection") || [];
  const [userId, setUserId] = useState(null);
  const [isFavLimitExceeded, setFavLimitExceeded] = useState(false);

  const [allowHistoryFavFeatures, setAllowHistoryFavFeatures] = useState(null);
  const qtConfigSections = useSelector((state) => get(state, ["qt", "config", "sections"], {}));
  useEffect(() => {
    const memberID = get(member, ["id"], "");

    if (memberID) {
      initAccessType(() => {
        getSubscriptionForUser()
          .then((res) => {
            const hasActiveSubs = Array.isArray(res?.subscriptions)
              ? res.subscriptions.some(sub => sub.status === "active")
              : false;

            if (hasActiveSubs) {
              setAllowHistoryFavFeatures(true);
            } else {
              setAllowHistoryFavFeatures(false);
            }
          })
          .catch((err) => {
            console.error("Error occurred inside profile page --->", err);
            setAllowHistoryFavFeatures(false);
          });
      });
    }
  }, [global.AccessType, member, isATGlobal]);

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const currentUserResp = await currentUser();
        const userId = currentUserResp?.user?.id || null;
        setUserId(userId);
      } catch (error) {
        console.error("Error fetching user id:", error);
      }
    };
    fetchUserId();
  }, []);

  let firstCollectionName = "";
  let summaryField = "";
  if (itemTypesCollections.length >= 1) {
    firstCollectionName = itemTypesCollections[0]?.slug;
    summaryField = itemTypesCollections[0]?.summary?.trim() || "No summary available";
    const collectionName = itemTypesCollections[0].name?.trim();
    const extractCollectionName = (collectionName) => collectionName?.split(" (")[0] || "";
    firstCollectionName = extractCollectionName(collectionName);
  }

  const itemTypesStories = collection.items?.filter((item) => item.type === "story") || [];
  const oldestToNewestMetas = itemTypesCollections?.[0]?.metadata["listing-order"]?.[0]?.name;
  const ageRestrictions = itemTypesCollections?.[0]?.metadata["age-restriction"]?.[0]?.name || null;
  const contentTypes = itemTypesCollections?.[0]?.metadata["content-type"]?.[0]?.name || null;

  let storyOrder = [];
  if (oldestToNewestMetas && oldestToNewestMetas === "Vanhin ensin") {
    storyOrder = [...itemTypesStories].sort((a, b) => a.story["published-at"] - b.story["published-at"]);
  } else {
    storyOrder = [...itemTypesStories].sort((a, b) => b.story["published-at"] - a.story["published-at"]);
  }
  const firstPublished = itemTypesStories?.sort((a, b) => a.story["published-at"] - b.story["published-at"]);
  //const heroImage= firstPublished?.[0]?.story["hero-image-s3-key"] || defaultImage;
  // following code commented, the old way to fetch promotion images
  /*const firstPublishedAltHomeImage =
    firstPublished?.[0]?.story.alternative?.home?.default?.["hero-image"]?.["hero-image-s3-key"] || defaultImage;
  const firstPublishedAltSocialImage =
    firstPublished?.[0]?.story.alternative?.social?.default?.["hero-image"]?.["hero-image-s3-key"] || defaultImage;*/
  // the new way to fetch promotion image
  const firstPublishedAltHomeImageTemp = itemTypesCollections[0]?.metadata?.webhero || defaultImage;
  const firstPublishedAltHomeImage = decodeURIComponent(
    firstPublishedAltHomeImageTemp.replace(/^https?:\/\/[^/]+\/?/, '').replace(/\?.*$/, '')
  );

  const firstPublishedAltSocialImageTemp = itemTypesCollections[0]?.metadata?.mobiilihero || defaultImage;
  const firstPublishedAltSocialImage = decodeURIComponent(
    firstPublishedAltSocialImageTemp.replace(/^https?:\/\/[^/]+\/?/, '').replace(/\?.*$/, '')
  );

  const firstPublishedImgS3 = [firstPublishedAltSocialImage, firstPublishedAltHomeImage, firstPublishedAltHomeImage];
  const imgAlt = firstPublished?.[0]?.story.headline;
  const latestEpisode = storyOrder?.[0]?.story ?? null;
  let ohjelmansiivulle = storyOrder?.[0]?.story.slug.split("/")[0] || "/";
  let episodeLink = storyOrder?.[0]?.story.slug || "/";
  if (storyOrder?.[0]?.story?.slug?.includes("lammas/")) {
    ohjelmansiivulle = `lammas/${episodeLink.split("/")[1]}`;
  }
  const [shareUrl, setShareUrl] = useState("");

  const [userFavData, setUserFavData] = useState(null);
  useEffect(() => {
    if (!userId) return;

    const fetchUserFavData = async () => {
      try {
        const responseData = await userFavouritesApi(userId);
        if (!responseData) {return;}
        setUserFavData(responseData);
      } catch (error) {
        console.error("Failed to fetch user favorites:", error);
      }
    };

    fetchUserFavData();
  }, [userId]);

  useEffect(() => {
    if (!userId || !latestEpisode || !userFavData || !userFavData?.length) {
      return;
    }

    const fetchFavoriteStatus = async () => {
      try {
        const favSectionID = latestEpisode?.sections?.[0]?.["parent-id"] ?? latestEpisode?.sections?.[0]?.id ?? null;
        const favSectionObj = qtConfigSections.find(sec => sec.id === favSectionID);
        const intCollectionID = favSectionObj?.collection?.id || "";
        const isFavFlagSelected = userFavData && Array.isArray(userFavData) && userFavData.some(item => item.asset_id == intCollectionID);

        if (isFavFlagSelected) {
          setFevSelected(true);
        }
      } catch (error) {
        console.error("Error fetching favorite status:", error);
      }
    };

    fetchFavoriteStatus();
  }, [latestEpisode, userFavData]);

  const handleFavBtn = async () => {
    if (!userId) return;

    try {
      const favSectionID = latestEpisode?.sections?.[0]?.["parent-id"] ?? latestEpisode?.sections?.[0]?.id ?? null;

      // before adding new fav, let's check if limit not exhausted
      if (!favSelected) {
        const isAllowed = await validateFavLimit(userId);
        if (!isAllowed) {
          setFavLimitExceeded(true);
          return;
        }
      }

      // before adding, let's prepare metadata variable
      let objMetadata={};
      const favSectionObj = qtConfigSections.find(sec => sec.id === favSectionID);
      const strCollectionSlug = favSectionObj?.collection?.slug || "";
      let collectionDetails = null;

      if (strCollectionSlug) {
        collectionDetails = await getCollections(strCollectionSlug);
        objMetadata["id"] = collectionDetails?.id || null;
        objMetadata["slug"] = collectionDetails?.slug || null;

        // loop through the metadata properly of the collectionDetails, and assign each key and value to objMetadata
        if (collectionDetails?.metadata) {
          Object.keys(collectionDetails.metadata).forEach(key => {
            objMetadata[key] = collectionDetails.metadata[key] || "";
          });
        }
      }

      const apiUrl = (favSelected ? "/user-favourites/delete"  : "/user-favourites/create");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId, asset_id: objMetadata?.id || null, metadata: objMetadata })
      });

      if (!response.ok) {
        throw new Error("Failed to update favorite status");
      }

      setFevSelected(!favSelected);
    } catch (error) {
      console.error("Error updating favorite status:", error);
      setFevSelected(!favSelected);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const cleanedPath = ohjelmansiivulle.replace(/^\/+/, "");
      setShareUrl(`${window.location.origin}/${cleanedPath}`);
    }
  }, []);

  return (
    firstPublishedImgS3.length > 0 && (
      <div styleName="container" className="hero1-container">
        <div styleName="image-wrapper">
          <div styleName="responsive-image">
            <Link href={episodeLink}>
              <figure>
                <ResponsiveImage
                  aspectRatio={[16, 9]}
                  defaultWidth={480}
                  widths={[250, 480, 640]}
                  slug={firstPublishedImgS3[currentImageIndex]}
                  alt={imgAlt}
                />
              </figure>
            </Link>
          </div>
          <div styleName="overlay">
            <div styleName="">
              <div styleName="section-info">
                <h2>{firstCollectionName}</h2>
                <p>{summaryField}</p>
              </div>
              <div styleName="overlay-buttons">
                {contentTypes && contentTypes === "Audio" && (
                  <Link href={episodeLink} styleName="btn-1">
                    <div styleName="podcast-btn-wrapper">
                      <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon" />
                      <p>Kuuntele</p>
                    </div>
                  </Link>
                )}
                {contentTypes && contentTypes === "Video" && (
                  <Link href={episodeLink} styleName="btn-1">
                    <div styleName="podcast-btn-wrapper">
                      <img alt="audio-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                      <p>Katsele</p>
                    </div>
                  </Link>
                )}
                {!contentTypes && (
                  <Link href={episodeLink} styleName="btn-1">
                    <div styleName="podcast-btn-wrapper">
                      <img alt="audio-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                      <p>Katsele</p>
                    </div>
                  </Link>
                )}
                <Link href={ohjelmansiivulle} styleName="btn-2 ohjelmasivule">
                  <img alt="audio-logo" src="/icons/ohjelmasivule.svg" styleName="custom-img-icon" />
                  <p>&nbsp;Ohjelmasivulle</p>
                </Link>
              <div styleName="button-wrapper">
                {allowHistoryFavFeatures && (
                    favSelected ? (
                      <div styleName="btn-2 add-to-fav-btn">
                        <div style={{display: "flex"}} onClick={handleFavBtn}>
                          <img alt="audio-logo" src="/icons/favorites-symbol-added-white.svg"  styleName="custom-img-icon"/>
                          <p>&nbsp;Omat suosikit</p>
                        </div>
                      </div>
                    ) : (
                      <div styleName="btn-2 add-to-fav-btn">
                        <div style={{display: "flex"}} onClick={handleFavBtn}>
                          <img alt="audio-logo" src="/icons/favorites-symbol-white.svg"  styleName="custom-img-icon"/>
                          <p>&nbsp;Omat suosikit</p>
                        </div>
                      </div>
                    )
                )}
                {ageRestrictions&&ageRestrictions==="15"&&<div styleName="k-16">
                  <p>K15</p>
                </div>}
                {ageRestrictions&&ageRestrictions==="18"&&<div styleName="k-16">
                  <p>K18</p>
                </div>}
                <div styleName="btn-2 jaa">
                  {shareUrl && (
                    <SocialShare url={shareUrl} defaultText="" btnStyle="small" />
                  )}
                </div>
              </div>
              {isFavLimitExceeded && (
                <div style={{ color: "white", marginTop: "10px", backgroundColor: "#333", padding: "10px", borderRadius: "5px" }}>
                  Olet saavuttanut suosikkien enimmäismäärän (20)! Lisätäksesi uuden suosikin, poista ensin jokin nykyisistä suosikeistasi.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
    )
  );
};

Hero1Layout.propTypes = {
  collection: object,
  config: object,
};

export { Hero1Layout };
Hero1Layout.storyLimit = 100;
